import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import LogRocket from 'logrocket';
import { FILE_UPLOAD_CONFIG, RENEWAL_MSGS, RESULTS_NOT_FOUND } from 'src/app/_common/product-config';
import { RenewalPolicyOptionsValue, RenewalSteps } from 'src/app/_common/_enum/module.enum';
import { HeaderData } from 'src/app/_models/header-data';
import { RenewalsService } from '../../_services/renewals.service';
import { environment } from 'src/environments/environment';
import { Renewal, RenewalMethods } from '../../_models/start-renewal';
import { StartRenewalBasicInfoComponent } from '../start-renewal-basic-info/start-renewal-basic-info.component';
import { StartRenewalReviewComponent } from '../start-renewal-review/start-renewal-review.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-start-renewal',
  templateUrl: './start-renewal.component.html',
  styleUrls: ['./start-renewal.component.scss']
})
export class StartRenewalComponent implements OnInit {

  public loading: boolean = false; //Using it in HTML
  public submitLoading: boolean = false; //Using it in HTML
  public renewalAPILoading: boolean = false; //Using it in HTML
  private hasAccess: boolean = true; //Using it in HTML
  private hasError: boolean = false;
  private isSubmitted: boolean = false;
  
  private renewalData;
  private accountDetails: any;
  private renewalNumber;

  //Create HeaderData object to show the Data on Blue Header.
  private headerData: HeaderData;
  private _renewalsMethods: RenewalMethods;
  private _renewal: Renewal;
  private RenewalSteps = RenewalSteps;

  private resultsNotFound = RESULTS_NOT_FOUND; //Using it in HTML
  private renewalMsgs = RENEWAL_MSGS; //Using it in HTML
  private fileUploadConfig = FILE_UPLOAD_CONFIG; //Using it in HTML
  private uploadedFileSize: number = 0;

  private modalReference;
  @ViewChild(StartRenewalBasicInfoComponent, {static: false}) startRenewalBasicInfo:StartRenewalBasicInfoComponent;
  @ViewChild(StartRenewalReviewComponent, {static: false}) startRenewalReview:StartRenewalReviewComponent;
  @ViewChild("cancelRenewalModal", {static: false}) cancelRenewalModal;
  constructor(private cdRef: ChangeDetectorRef ,public readonly route: ActivatedRoute, private readonly router: Router, private modalService : NgbModal, private renewalsService: RenewalsService) { }

  ngOnInit() {
    this._renewalsMethods = new RenewalMethods();
    this._renewal = new Renewal();
    this.renewalData = this._renewal.renewalData;

    
    //Getting Renewal Number for State params
    this.route.paramMap.subscribe(params => {
      this.renewalNumber = params.get("id").toString();
    });

     /* Setting Headers Starts */
      this.headerData = new HeaderData();
      this.setHeaderData();
    /* Setting Headers Ended */
    this.renewalsService.setSupportingDocuments([]);

    if(history && history.state && history.state.accountDetails) {
      this.accountDetails = history.state.accountDetails;

      console.log(this.accountDetails);
    }
    
    this._renewal.selectedStep = RenewalSteps.BasicInfo;//RenewalSteps.Success;//RenewalSteps.Review;//
    this.renewal = this._renewal;
  }

  ngAfterViewChecked() {
    if (this._renewal != this.renewal) {
      this._renewal = this.renewal;
    }
    this.cdRef.detectChanges();
  }

  setHeaderData(_pageTitle = "Start Renewal", _addBreadcrumb = false){
    this.headerData.pageTitle = _pageTitle;
    if(_addBreadcrumb)
      this.headerData.breadcrumb = [{itemName: "❮ Back to Manage Renewal", itemLink: "../renewals/"+this.renewalNumber + "/"+this.renewalData.account.accountNumber +"/manage"}];

    this.renewalsService.header = this.headerData;
  }
  
  getContinueButtonName(){
    this._renewal = this.renewal;
    if(this._renewal.selectedStep == this.RenewalSteps.BasicInfo){
      return "Continue to Review";
    }else if(this._renewal.selectedStep == this.RenewalSteps.Review){
      return "Submit Renewal";
    }
  }
  
  get selectedStep(){
    return this.renewalsService.selectedStep;
  }
  set selectedStep(_step){
    this._renewal.selectedStep = _step;
    this.renewalsService.selectedStep = _step;
  }
  get renewal(){
    return this.renewalsService.renewal;
  }
  set renewal(_renewal){
    this.renewalsService.renewal = _renewal;
  }

  getUploadedFileSize($event) {
    this.uploadedFileSize = $event;
  }

  public onCancel(){
    this.modalReference = this.modalService.open(this.cancelRenewalModal, { centered: true, backdropClass: 'light-blue-backdrop' });
    this.modalReference.result.then((result) => {
      console.log("closed");
      }, (reason) => {
        console.log("dismissed");
    });
  }

  cancelRenewal(){
    if(environment.logRocketKey){
      LogRocket.log("(LogRocket) CancelRenewal : " + true);
      let loggedInUser = this.renewalsService.getLoggedInProfile();
      LogRocket.identify(loggedInUser.UID.toString(), {
        CancelRenewal: true
      });
    }
    this.modalReference.close();
    this.router.navigate(["renewals/"+this.renewalNumber+ "/"+this.renewalData.account.accountNumber+"/manage"]);
  }
  onEdit() {
    this._renewal.selectedStep = RenewalSteps.BasicInfo;
    this._renewal.fromReview = true;
    this.renewal = this._renewal;
    window.scrollTo(0, 0);
  }

  onContinue() {    
    this.isSubmitted = true;
    if (this.selectedStep == RenewalSteps.BasicInfo) {
      if (this.startRenewalBasicInfo.onContinue()) {
        this.selectedStep = RenewalSteps.Review;
        this.renewal.selectedStep = RenewalSteps.Review;
        window.scrollTo(0, 0);
      }else{
        console.log("invalid basic info continue");
      }
    }else if(this.selectedStep == RenewalSteps.Review){
      if (this.startRenewalReview.onContinue()) {
        
        this._renewal = this.renewalsService.getRenewalData();
        if (this._renewal.renewalData.account && this._renewal.renewalData.account.originalName === this._renewal.renewalData.account.requestedName) {
          this._renewal.renewalData.account.requestedName = "";
        }
        if (this._renewal.renewalData.address && this._renewal.renewalData.address.original) {
          this._renewal.renewalData.address.original = this._renewal.renewalData.address.original.map(_address => _address.addressLine1==""?_address = null:_address);
        }
        if(this._renewal.renewalData.address && this._renewal.renewalData.address.requested){
          if (this._renewal.renewalData.address.requested.every((_address) => !_address.isEdited)) {
            this._renewal.renewalData.address.requested = [];
          } else {
            this._renewal.renewalData.address.requested = this._renewal.renewalData.address.requested.map(_address => !_address.isEdited?_address = null:_address);
          }
        }
        if (this._renewal.renewalData.contacts && this._renewal.renewalData.contacts.requested) {
          if (this._renewal.renewalData.contacts.requested.every((_contact) => !_contact.isEdited)) {
            this._renewal.renewalData.contacts.requested = [];
          } else {
            this._renewal.renewalData.contacts.requested = this._renewal.renewalData.contacts.requested.map(_contact => !_contact.isEdited ? _contact = null : _contact);
          }
        }
        this.renewal = this._renewal;
        window.scrollTo(0, 0);

        console.log("uploading files");
        let newSupportingDocuments = [];
        this.loading = true;
        this.submitLoading = true;
        if(this.renewalsService.getSupportingDocuments().length>0){
          this.renewalsService.getSupportingDocuments().forEach((document, index) => {
             let newFile:any = {};
              newFile.name= document.name;
              newFile.lastModified= document.lastModified;
              newFile.lastModifiedDate= document.lastModifiedDate;
              newFile.webkitRelativePath= document.webkitRelativePath;
              newFile.size= document.size;
              newFile.type= document.type;
              newFile.docFileType = document.docFileType;
  
              ((_document, _newFile)=>{
                let fReader = new FileReader();
                // Add complete behavior
                fReader.onload = ()=>{
                  _newFile.content = fReader.result;
                  _newFile.content = _newFile.content.split("base64,")[1];
  
                  //console.log(_newFile.content);
                  newSupportingDocuments.push(_newFile);
  
                  if(newSupportingDocuments.length == this.renewalsService.getSupportingDocuments().length){
                    this.submitRequest(newSupportingDocuments);
                  }else{
                    console.log("uploading file " + index);
                  }
                };
                fReader.readAsDataURL(_document);
              })(document, newFile);   
          });
        }else{
          this.submitRequest([]);
        }
      }else{
        console.log("invalid basic info continue");
      }
    }
  }
  
  submitRequest(newSupportingDocuments){
    console.log("Submitting request");
    let finalRenewalData = this._renewalsMethods.getFinalRenewalData(this._renewal.renewalData);
    finalRenewalData.attachments = newSupportingDocuments;
    
    
    this.renewalsService.submitRenewal(finalRenewalData).subscribe(()=>{
      this.loading = false;
      this.submitLoading = false;
      console.log("Submitted!!");
      
      if(environment.logRocketKey){
        LogRocket.log("(LogRocket) RenewalSubmitted : " + true);
        let loggedInUser = this.renewalsService.getLoggedInProfile();
        LogRocket.identify(loggedInUser.UID.toString(), {
          RenewalSubmitted: true
        });
      }

      if(this._renewal.renewalData.renewingPolicies.every(_policy => _policy.renewOption == RenewalPolicyOptionsValue.DO_NOT_RENEW)){
        this.selectedStep = this.RenewalSteps.Decline;
        this.renewal.selectedStep = this.RenewalSteps.Decline;
        this._renewal = new Renewal();
        this._renewal.selectedStep = this.RenewalSteps.Decline;
      }else{
        this.selectedStep = this.RenewalSteps.Success;
        this.renewal.selectedStep = this.RenewalSteps.Success;
        this._renewal = new Renewal();
        this._renewal.selectedStep = this.RenewalSteps.Success;
      }

      this.renewal = this._renewal;
      this.setHeaderData("Renewal Request Submitted", true);
      //this.renewalsService.storeRenewalAccountData({});
    },error=>{          
      this.loading = false;
      this.submitLoading = false;
    });
    console.log(JSON.stringify(finalRenewalData));
  }

}
